import { Checkbox } from "@components/ui/checkbox";
import { Controller } from "react-hook-form";

const Review: React.FC<any> = ({ setValue, watch }) => {
  const fields = watch();

  const jobFields = [
    { label: "Job title", value: fields?.jobTitle },
    { label: "Job location", value: fields?.jobLocation },
    { label: "Industry type", value: fields?.industryType },
    { label: "Work place", value: fields?.workPlaceOption },
    { label: "Job type", value: fields?.jobType },
    {
      label: "Salary Range",
      value: `£${fields?.salaryRangeFrom} - £${fields?.salaryRangeTo}`,
    },
  ];


  return (
    <div className="flex  flex-col p-6 md:p-10 max-w-5xl mx-auto w-3/4">
      <div className="flex flex-col flex-1 gap-5  w-3/4 self-center">
        <div className="flex items-center gap-3">
          <Checkbox
            id="sharedToAllAgencies"
            checked={fields?.isSharedToAllAgencies}
            onCheckedChange={(checked) =>
              setValue("isSharedToAllAgencies", checked === true)
            }
          />
          <label
            htmlFor="sharedToAllAgencies"
            className="font-semibold text-xs"
          >
            Share job requirement to all the agencies
          </label>
        </div>
        {jobFields.map((field, idx) => (
          <div key={idx} className="flex ">
            <span className="min-w-[160px] font-semibold text-xs">
              {field.label} :
            </span>
            <span className="font-normal text-xs">{field.value}</span>
          </div>
        ))}
      </div>
      <hr className="my-8 border-t border-dashed border-gray-300" />
      <div className="flex items-start w-3/4 self-center flex-col gap-3 mt-3">
        <span className="min-w-[160px] font-semibold text-xs">
          Job Description :
        </span>
        <p
          className="font-normal text-xs leading-6"
          dangerouslySetInnerHTML={{ __html: fields?.jobDescription }}
        />
      </div>
      <hr className="my-8 border-t border-dashed border-gray-300" />
      <div className="flex flex-col w-3/4 self-center">
        <h3 className="font-semibold text-xs text-primary">
          Skills required :
        </h3>
        <div className="h-full flex flex-1 flex-col mt-3">
          <div className="overflow-auto h-full w-full">
            {fields?.skills?.map((skill) => (
              <div
                key={skill?._id}
                className="grid space-x-3 py-2.5 items-center w-full justify-center relative grid-cols-[1.7fr_0.68fr_0.58fr_1fr]"
              >
                {[
                  skill.skill,
                  `${skill.level}/10`,
                  skill.experience,
                  skill.lastUsed,
                ].map((value, index) => (
                  <div
                    key={index}
                    className="border border-gray-100 bg-[#FAFAFA] px-4 py-2.5 text-xs font-medium text-primary rounded flex flex-1"
                  >
                    {value}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Review;
